import styled from 'styled-components';
import Button from '@/components/core/Button';
import Icon from '@/components/core/Icon/Icon';
import { FlexSpaceBetween } from '@/components/Flex';
import { device } from '@/components/Media';

export const ForgotPasswordButton = styled(Button)`
    height: 24px;
`;

export const StyledIcon = styled(Icon)`
    color: ${({ theme }) => theme.colors.palette.grey_800};
    cursor: pointer;
`;

export const FieldsBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;

  @media ${device.laptopS} {
    width: 100%;
    gap: 12px;
  }
`;

export const StyledFlexSpaceBetween = styled(FlexSpaceBetween)`
  width: 100%;
`;

export const OrBlock = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
`;

export const Line = styled.div`
  height: 1px;
  border: 0.5px solid ${({ theme }) => theme.colors.palette.grey_450};
  width: 100%;
`;

export const GoogleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  
  @media ${device.laptopS} {
    width: 100%;
  }
`;
